import React from 'react'
import { FaFacebook, FaGooglePlus, FaInstagram, FaTwitter } from 'react-icons/fa'
import '../Styles/Footer.css'

const Footer = () => {
    return (
        <div className='footer-container'>
            <div className="logo block">
                Workmate
            </div>
            <div className="company block">
                <h3 className="Head">
                    Company
                </h3>
                <ul className="links">
                    <li>
                        link
                    </li>
                    <li>
                        link
                    </li>
                    <li>
                        link
                    </li>
                    <li>
                        link
                    </li>
                    <li>
                        link
                    </li>

                </ul>
            </div>

            <div className="community block">
                <h3 className="Head">
                    Community
                </h3>
                <ul className="links">
                    <li>
                        link
                    </li>
                    <li>
                        link
                    </li>
                    <li>
                        link
                    </li>
                    <li>
                        link
                    </li>

                </ul>
            </div>

            <div className="help block">
                <h3 className="Head">
                    Help
                </h3>
                <ul className="links">
                    <li>
                        link
                    </li>
                    <li>
                        link
                    </li>
                    <li>
                        link
                    </li>
                    

                </ul>
            </div>

            <div className="social block">
                <FaFacebook className='icons'/>
                <FaTwitter className='icons'/>
                <FaInstagram className='icons'/>
                <FaGooglePlus className='icons'/>
            </div>
        </div>
    )
}

export default Footer
